import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import About from "../components/About";
import FeaturedSkills from "../components/FeaturedSkills";
import Footer from "../components/Footer";

import { FormEmail } from "../components/Forms/EmailForm";
import Navbar from "../components/Navbar";
import Project from "../components/Projects";

import profilePic from "../images/pixlr-bg-result4.png";

import "./home.css";

export const Home = () => {
  return (
    <div className="page-container">
      <section className="page-content">
        <Navbar />
        <div className="profile-media" id="profile">
          <div className="social-links">
            <a href="https://www.github.com/luisgustavogorniak" target="blank">
              <FaGithub color="black" size={50} className="social-icon" />
            </a>
            <a
              href="https://www.linkedin.com/in/luisgustavogorniak"
              target="blank"
            >
              <FaLinkedin color="black" size={50} className="social-icon" />
            </a>
          </div>

          <div className="profile-picture-container">
            <img className="profile-picture" src={profilePic} alt="profile" />
          </div>

          <div className="title">
            <h2>Luís Gustavo Gorniak</h2>
            <h6 className="linus">
              <i>“Talk is cheap. Show me the code.”</i>
            </h6>
            <h6>Linus Torvalds</h6>
            <h1>web developer</h1>
          </div>
        </div>

        <div className="about-me" id="about">
          <About />
        </div>

        <div className="featured-skills" id="skills">
          <FeaturedSkills />
        </div>

        <div className="projects" id="projects">
          <Project />
        </div>

        <div>
          <FormEmail />
        </div>

        <div className="footer-container" id="contact">
          <Footer />
        </div>
      </section>
    </div>
  );
};
